import React, { Component } from 'react'
import './header.sass'
import { MAP_SIZES_TO_PROPS } from '../../../constants'

import withSizes from 'react-sizes'
import { compose } from 'recompose'
import LoginSignupModal from '../../auth/shells/loginSignupModal'
import { Container, Columns } from '../../elements'
import Searchbar from '../searchAutoComplete/searchAutoComplete'
import MapboxSearchBar from '../mapboxSearchAutoComplete/mapboxSearchAutoComplete'
import { Subscribe } from 'unstated'
import TRLOGO from '../assets/images/new-twistedroad-logo.webp'
import SearchContainer from '../../context/SearchContainer'
import MobileMenu from '../mobileMenu/mobileMenu'
import MenuRight from './rightMenu/rightMenu'

let classnames = require('classnames')

class MainHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalViewType: false,
      modalOpen: false,
    }
  }

  componentDidMount() {
    let advertisements = sessionStorage.getItem("allAdvertisements")
    if (!advertisements) {
      this.props.auth.fetchAdvertisements()
    }
    this.props.auth.whoAmI()
  }

  openLoginModal = (viewType, updateAuthState) => {
    this.setState({
      modalOpen: true,
    })
    updateAuthState()
  }

  closeModal = (updateAuthState) => {
    updateAuthState()
    this.setState({
      modalOpen: false,
    })
  }

  logOut = (updateAuthState) => {
    updateAuthState()
  }

  render() {
    const { isAuth, isMobile, auth } = this.props

    const showMobileMenu = this.props.isMobile || this.props.isTablet

    let headerClassName = classnames('main-header-wrap', this.props.className, {
      'desktop-header': !this.props.isMobile,
      'mobile-header': this.props.isMobile,
    })

    return (
      <Subscribe to={[SearchContainer]}>
        {(search) => {
          return (
            <div id="main-header-wrap" className={headerClassName}>
              <Container className="large mt-0 mb-0">
                <Columns
                  className="is-vcentered is-centered is-mobile"
                  style={{ marginTop: 0, marginBottom: 0 }}
                >
                  <Columns.Column size={isMobile ? 4 : 2} className="is-narrow">
                    <div className="header-logo-wrap">
                      <a href="/">
                        <img
                          src={TRLOGO}
                          alt="Twisted Road: Motorcycle Rentals"
                          className="is-block"
                          id="homepage-logo"
                          width="196px"
                          height="44px"
                        />
                      </a>
                    </div>
                  </Columns.Column>
                  <Columns.Column>
                    <div className="header-search-bar-column">
                      <MapboxSearchBar
                        selectSubmit={true}
                        isMobile={this.props.isMobile}
                        defaultAddress={search.state.location}
                        searchObject={search}
                        className="header-search is-medium"
                        isHeaderSearchbar={true}
                        headerBar={true}
                        searchFrom="headerBar"
                      />
                    </div>
                  </Columns.Column>
                  <Columns.Column className="is-narrow is-hidden-mobile">
                    <MenuRight
                      isMobile={this.props.isMobile}
                      isAuth={isAuth}
                      loginModalFunction={this.openLoginModal}
                      logoutFunction={this.logOut}
                      authObject={auth}
                    />
                  </Columns.Column>
                  {showMobileMenu && (
                    <Columns.Column className="is-narrow is-hidden-desktop">
                      <MobileMenu
                        isMobile={this.props.isMobile}
                        isAuth={isAuth}
                        onClose
                        loginModalFunction={this.openLoginModal}
                        logoutFunction={this.logOut}
                        authObject={auth}
                      />
                    </Columns.Column>
                  )}
                </Columns>
              </Container>

              {auth.state.modalViewType && (
                <LoginSignupModal
                  modalOpen={auth.state.modalOpen}
                  viewType={auth.state.modalViewType}
                  onClose={() => this.closeModal(auth.onModalClose)}
                />
              )}
            </div>
          )
        }}
      </Subscribe>
    )
  }
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(MainHeader)

MainHeader.defaultProps = {
  isAuth: true,
}
